import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';

export class ErrorRequired extends React.Component {
  render() {
    return (
      this.props.isDisplay ?
      <span when="required" className="invalid-feedback">
         <FormattedMessage {...messages.error.required} />
      </span>
        : null
    );
  }
}

ErrorRequired.propTypes = {
  isDisplay: PropTypes.bool,
};
